import { API_URL } from '../config/config';
import { getRequest } from '../utils/axiosUtils';

export async function fetchSummaryByType(
  type,
  { isAdmin = false, params = {} } = {}
) {
  const url = `${API_URL}/summary`;
  try {
    const res = await getRequest({
      url,
      params: { type, isAdmin, ...params },
    });

    if (!res || !res.data) {
      throw new Error('No response from server');
    }
    if (res.data.success === false) {
      throw new Error(res.data.message || 'Failed to fetch summary');
    }

    const raw =
      (Array.isArray(res.data.data) && res.data.data) ||
      (Array.isArray(res.data.items) && res.data.items) ||
      (Array.isArray(res.data.summary) && res.data.summary) ||
      [];

    return raw.map((item, idx) => ({
      key: item.key ?? item.status ?? item.name ?? `${type}-${idx}`,
      label: item.label ?? String(item.status ?? item.name ?? 'Unknown'),
      count: Number(item.count ?? item.total ?? 0),
    }));
  } catch (err) {
    console.error(`Error fetching summary for type "${type}":`, err);
    throw err;
  }
}